import React, { createContext, useState, useCallback, useContext } from "react"
import { SystemMessage, SystemMessageProps } from "./SystemMessage"

type SystemMessageProviderProps = {
  offsetTop?: number
  offsetRight?: number
}

export const SystemMessageContext = createContext<
  // We need a typescript-compatible eslint config to avoid the following error
  // eslint-disable-next-line no-unused-vars
  (message: SystemMessageProps) => void
>(() => null)

export const SystemMessageProvider: React.FC<SystemMessageProviderProps> = ({
  children,
  offsetTop = 0,
  offsetRight = 16,
  ...rest
}) => {
  const [messages, setMessages] = useState<SystemMessageProps[]>([])
  const [hiddenItemsCount, setHiddenItemsCount] = useState(0)

  const openSystemMessage = useCallback(
    (message: SystemMessageProps): void => {
      setMessages([...messages, message])
    },
    [messages]
  )

  const onHide = (): void => {
    // Once all messages have been hidden, we reset the state of the SystemMessage
    const newHiddenItemsCount = hiddenItemsCount + 1

    if (newHiddenItemsCount === messages.length) {
      setMessages([])
      setHiddenItemsCount(0)
    } else {
      setHiddenItemsCount(newHiddenItemsCount)
    }
  }

  const snackbarItems = messages.map(({ text, kind }, index) => (
    <SystemMessage key={index} text={text} kind={kind} onHide={onHide} />
  ))

  return (
    <SystemMessageContext.Provider value={openSystemMessage}>
      {children}
      {messages.length ? (
        <div
          className="pointer-events-none fixed top-0 right-0 z-20 flex flex-col items-end"
          style={{
            top: offsetTop + 16,
            right: offsetRight,
            margin: 0,
          }}
          {...rest}
        >
          {snackbarItems}
        </div>
      ) : null}
    </SystemMessageContext.Provider>
  )
}

export const useSystemMessage = () => useContext(SystemMessageContext)
